import { render, staticRenderFns } from "./PigaiEdit.vue?vue&type=template&id=0c8807f5&scoped=true"
import script from "./PigaiEdit.vue?vue&type=script&lang=js"
export * from "./PigaiEdit.vue?vue&type=script&lang=js"
import style0 from "./PigaiEdit.vue?vue&type=style&index=0&id=0c8807f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8807f5",
  null
  
)

export default component.exports